import { forwardRef } from "react";
import { Select as MUISelect, MenuItem, Typography } from "@mui/material";
import { SelectProps } from "./Select.props";
import { useTranslation } from "react-i18next";

const Select = forwardRef<HTMLSelectElement, SelectProps>(
  ({ options, defaultValues, fieldError, onDelete, ...rest }, ref) => {
    // destructures
    const { t } = useTranslation();
    const { label } = rest;

    return (
      <>
        <MUISelect
          id={`${label}-select`}
          labelId={`${label}-label`}
          inputRef={ref}
          {...rest}
          style={{
            position: "relative",
          }}
          MenuProps={{
            keepMounted: true,
            disablePortal: true,
            PaperProps: {
              style: {
                maxHeight: 300,
                maxWidth: 250,
                width: "fit-content",
              },
            },
          }}
        >
          {options?.map(({ id, name }: any) => (
            <MenuItem
              key={id}
              value={id}
              style={{
                whiteSpace: "normal",
                wordWrap: "break-word",
              }}
            >
              {name}
            </MenuItem>
          ))}
        </MUISelect>
        {fieldError && (
          <Typography sx={{ color: "red" }} variant="caption" display="block">
            {fieldError?.message}
          </Typography>
        )}
      </>
    );
  }
);

Select.displayName = "Select";
export default Select;
